import { render } from "./AddEntityTab.vue?vue&type=template&id=7c0211de&scoped=true"
import script from "./AddEntityTab.vue?vue&type=script&lang=js"
export * from "./AddEntityTab.vue?vue&type=script&lang=js"

import "./AddEntityTab.vue?vue&type=style&index=0&id=7c0211de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c0211de"]])

export default __exports__